<template>
  <div
    class="border-gray-200 sticky bottom-0 z-50 flex bg-white"
    :class="{
      'flex-row gap-4 p-4 sm:px-0 sm:py-4': isAddToBasketPopover,
      'flex-col border-t p-4': !isAddToBasketPopover,
      'pb-14': isAddToBasketPopover && isSafari && isMobile,
    }"
    @click.capture="$emit('close')"
  >
    <Button
      v-if="isAddToBasketPopover"
      type="tertiary"
      class="w-full cursor-pointer border border-gray-secondary bg-white p-2 text-center text-sm uppercase text-black"
      data-qa="go-to-checkout"
      @click.capture="$emit('close')"
      >{{ $t('wishlist.continue_shopping_label') }}</Button
    >
    <NuxtLink
      v-if="!isAddToBasketPopover"
      :to="toLocalePath({ name: 'checkout' })"
      class="w-full bg-primary p-2 text-center text-sm font-bold uppercase text-white"
      data-qa="go-to-checkout"
      >{{ $t('basket.checkout_label') }}</NuxtLink
    >
    <NuxtLink
      :to="toLocalePath({ name: 'basket' })"
      class="flex w-full items-center justify-center p-2 text-center text-sm uppercase"
      :class="{
        'bg-primary font-bold text-white': isAddToBasketPopover,
        'mt-4 border border-black bg-white text-black': !isAddToBasketPopover,
      }"
      data-qa="show-cart"
      >{{ $t('basket.heading') }}</NuxtLink
    >
  </div>
</template>

<script setup lang="ts">
import useRouteHelpers from '~/composables/useRouteHelpers'
import useBrowserDetection from '~/composables/useBrowserDetection'

defineProps({
  isAddToBasketPopover: Boolean,
})
const { toLocalePath } = useRouteHelpers()
const { isSafari } = useBrowserDetection()
const { isMobile } = useDeviceType()

defineEmits(['close'])
</script>
